import { connect } from 'react-redux';

import RecipesLanding from 'components/RecipesLanding/RecipesLanding';

import { getLoading, getLocationHash, getPageNotFound } from 'redux/modules/cms-page/selectors';

import {
  getContentUrl,
  getMetaData,
  getBreadcrumbs,
  getPageTitle,
  getCurrentPage,
  getIsFirstPage,
  getIsLastPage,
  getImage,
  getLocations,
} from 'redux/modules/cms-hybrid-recipes-page/selectors';

import { getCurrentPageDepth } from 'redux/modules/page/selectors';

const mapStateToProps = state => ({
  breadcrumbs: getBreadcrumbs(state),
  components: getLocations(state),
  contentUrl: getContentUrl(state),
  currentPage: getCurrentPage(state),
  hash: getLocationHash(state),
  loading: getLoading(state),
  metaData: getMetaData(state),
  pageTitle: getPageTitle(state),
  isFirstPage: getIsFirstPage(state),
  isLastPage: getIsLastPage(state),
  pageNotFound: getPageNotFound(state),
  image: getImage(state),
  taxonomyLevel: getCurrentPageDepth(state),
});

export default connect(mapStateToProps)(RecipesLanding);
